// extracted by mini-css-extract-plugin
module.exports = {"paymentMethod":"CardPaymentMethodItem__paymentMethod__UOb6e"};